import { render } from "./ViewerPoster.vue?vue&type=template&id=36118532&scoped=true&ts=true"
import script from "./ViewerPoster.vue?vue&type=script&lang=ts"
export * from "./ViewerPoster.vue?vue&type=script&lang=ts"

import "./ViewerPoster.vue?vue&type=style&index=0&id=36118532&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36118532"]])

export default __exports__